// extracted by mini-css-extract-plugin
export default {"container":"VerifyBankWithPlaidScreen_container__ukEcu","visuallyHidden":"VerifyBankWithPlaidScreen_visuallyHidden__-gyXr"};